import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import { homeAppSelector } from '@/constants'
import Home from './Home.vue'

const els = document.querySelectorAll<HTMLElement>(homeAppSelector)

/**
 * Create an i18n instance.
 */
const i18n = createI18n({
    availableLocales: ['en'],
    locale: 'en-AU',
    fallbackLocale: 'en-AU',
    legacy: false
})

for (const el of els) {
    const app = createApp(Home, {
        dimension: el?.dataset.dimension
    })

    app.use(i18n)

    app.mount(el)
}
